import {
    inject,
    Injectable
} from '@angular/core';

import {
    restManager
} from 'app/ajs-upgraded-providers';

import {
    GetFoliosResponse,
    BedzzleCommonTransaction
} from 'src/app/features/digital-payments';

@Injectable({
    providedIn: 'root'
})
export class SpiaggeItApiService {
    private readonly restManager = inject(restManager);

    public setupShop(paymentMethodId: number, propertyId: string): Promise<any> {
        return this.restManager.post('spiagge_it/setup', { propertyId: propertyId }, { tilbyPaymentId: paymentMethodId });
    }

    public getRoomFolios(paymentMethodId: number): Promise<GetFoliosResponse> {
        return this.restManager.getList('spiagge_it/room_folios', { tilbyPaymentId: paymentMethodId });
    }

    public getMiscSalesFolios(paymentMethodId: number): Promise<GetFoliosResponse> {
        return this.restManager.getList('spiagge_it/misc_sales_folios', { tilbyPaymentId: paymentMethodId });
    }

    public createTransaction(paymentMethodId: number, transactionData: BedzzleCommonTransaction) {
        return this.restManager.post('spiagge_it/transactions', transactionData, { tilbyPaymentId: paymentMethodId });
    }

    public rollbackTransaction(paymentMethodId: number, outletId: string, orderId: string) {
        return this.restManager.deleteOne('spiagge_it/transactions', null, { orderId: orderId, outletId: outletId, tilbyPaymentId: paymentMethodId });
    }
};